import React from 'react';
import { Link } from 'react-router-dom';

const Row50 = props => {
  const { item, openArrangement } = props;

  const openConfigurator = id => {
    openArrangement(id);
    localStorage.removeItem('copyWardrobe');
  };

  if (item.id === 'accessories-shop') {
    return (
      <div className="masonry__tile-wrapper">
        <div className="title__box title__box-flex">
          <span className="title title--first-word">{item.first_word}</span>
          <span className="title title--secound-word">{item.secound_word}</span>
        </div>
        <Link
          to={item.link}
          className="masonry__tile masonry__tile--50 masonry__tile--shop"
          onClick={() => openArrangement(item.id)}
          key={item.id}>
          <div className="masonry__tile-button">
            OTWÓRZ <i className="icon-small-arrow"></i>
          </div>
        </Link>
      </div>
    );
  }

  if (item.id === 'start-configuration') {
    return (
      <div className="masonry__tile-wrapper">
        <div className="title__box">
          <span className="title title--first-word">{item.first_word}</span>
          <span className="title title--secound-word">{item.secound_word}</span>
        </div>
        <Link
          to={item.link}
          className="masonry__tile masonry__tile--50 masonry__tile--start"
          onClick={() => openConfigurator(item.id)}>
          <div className="masonry__tile-button">
            OTWÓRZ <i className="icon-small-arrow"></i>
          </div>
        </Link>
      </div>
    );
  }

  return null;
};

export default Row50;
